import Common from "../../../../Common"

export interface WallboardThemeColor {
	id: id
	class: string
}

const Color = class extends Common {
	browse = (companyId: id): CustomResponse<WallboardThemeColor[]> =>
		this.get(`/company/${companyId}/wallboard/theme/color`)
}

export default Color
